const type = "SENSOR_GRAPH/";

export const sensorGraphConstants = {
  LISTING_REQUEST: `${type}LISTING_REQUEST`,
  LISTING_SUCCESS: `${type}LISTING_SUCCESS`,
  LISTING_FAILURE: `${type}LISTING_FAILURE`,

  BULK_LISTING_REQUEST: `${type}BULK_LISTING_REQUEST`,
  BULK_LISTING_SUCCESS: `${type}BULK_LISTING_SUCCESS`,
};
